import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'

export const useDeleteQR = ({ onSuccess, onError }: { onSuccess: () => void; onError: (error: Error) => void }) => {
  const { mutate: deleteQR } = useMutation<void, Error, { id: number }>({
    mutationFn: (opts) => Request.delete(Request.urls.bank.reportQuarterly, { id: opts.id }),
    onSuccess: () => {
      if (onSuccess) {
        onSuccess()
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error)
      }
    }
  })

  return {
    deleteQR
  }
}
